import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IOrders } from '../interfaces/orders';
import { IOrder } from '../interfaces/order';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(private _apiService: ApiService) {}

  orders(arr: any): Observable<IOrders> {
    let urlParams = new HttpParams();
    for (let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString());
    }

    return this._apiService.doGET('orders', urlParams).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  rupturesStatistics(start_date, end_date): Observable<any> {
    //Filtrar datas para formato esperado em back-end
    //=============================================================
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService
      .doGET(
        'orders/missing-products/statistics?start_date=' +
          start_date +
          '&end_date=' +
          end_date
      )
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  lastSixOrders(start_date, end_date): Observable<any> {
    //Filtrar datas para formato esperado em back-end
    //=============================================================
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService
      .doGET(
        'orders?limit=6&idestabelecimento=all&start_date=' +
          start_date +
          '&end_date=' +
          end_date
      )
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  ordersStatistics(start_date, end_date): Observable<any> {
    //Filtrar datas para formato esperado em back-end
    //=============================================================
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService
      .doGET(
        'orders/statistics?start_date=' + start_date + '&end_date=' + end_date
      )
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  ordersMetas(start_date, end_date): Observable<any> {
    //Filtrar datas para formato esperado em back-end
    //=============================================================
    start_date = new Date(start_date).toISOString().split('T')[0];
    end_date = new Date(end_date).toISOString().split('T')[0];
    return this._apiService
      .doGET(
        'orders/metas?start_date=' + start_date + '&end_date=' + end_date
      )
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  show(id): Observable<any> {
    return this._apiService.doGET('orders/' + id).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  showSignature(id): Observable<any> {
    return this._apiService.doGET('orders/' + id + '/signature').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  transfer(id, data): Observable<any> {
    return this._apiService.doPATCH('orders/' + id + '/transfer', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  changeSituation(id, data): Observable<any> {
    return this._apiService
      .doPATCH('orders/' + id + '/change-situation', data)
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  changeSchedule(id, data): Observable<any> {
    return this._apiService.doPATCH('orders/' + id + '/schedule', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  tryAnotherCapture(id): Observable<any> {
    return this._apiService
      .doPATCH('orders/' + id + '/try-another-capture')
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  onManualTransactionRelease(id): Observable<any> {
    return this._apiService
      .doPATCH('orders/' + id + '/manual-transaction-release')
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  changeToDelivery(id, data): Observable<any> {
    return this._apiService.doPATCH('orders/' + id + '/to-delivery', data).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  changeToDriveThru(id): Observable<any> {
    return this._apiService.doPATCH('orders/' + id + '/to-drivethru').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  resendPDV(id): Observable<any> {
    return this._apiService.doPATCH('orders/' + id + '/resend-pdv').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  confirmaRelease(id): Observable<any> {
    return this._apiService
      .doPATCH('orders/' + id + '/confirmation-release', {
        requer_confirmacao: 'C',
      })
      .pipe(
        catchError((err) => {
          return observableOf([]);
        })
      );
  }

  addCupom(id, cupom): Observable<any> {
    return this._apiService.doPOST(`orders/${id}/coupon/${cupom}`).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }
}
